import { BuInstancesTable } from "@/components/bu-instances/BuInstancesTable";

/** Thin wrapper around `BuInstancesTable`. */
export function BuInstancesTab() {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Coach Manager Business Unit connections used to copy PrivateHire requests, Contracts, and
        Quotations between BUs. Credentials are admin-only and are never displayed once saved.
      </p>
      <BuInstancesTable />
    </div>
  );
}
